__turbopack_context__.v({
  "animateOpacity": "TurnrModal-module-scss-module__23KbFq__animateOpacity",
  "back-button": "TurnrModal-module-scss-module__23KbFq__back-button",
  "blowUpContent": "TurnrModal-module-scss-module__23KbFq__blowUpContent",
  "blowUpContentTwo": "TurnrModal-module-scss-module__23KbFq__blowUpContentTwo",
  "blowUpModal": "TurnrModal-module-scss-module__23KbFq__blowUpModal",
  "blowUpModalTwo": "TurnrModal-module-scss-module__23KbFq__blowUpModalTwo",
  "bondJamesBond": "TurnrModal-module-scss-module__23KbFq__bondJamesBond",
  "button": "TurnrModal-module-scss-module__23KbFq__button",
  "buttons": "TurnrModal-module-scss-module__23KbFq__buttons",
  "close-button": "TurnrModal-module-scss-module__23KbFq__close-button",
  "content": "TurnrModal-module-scss-module__23KbFq__content",
  "fadeIn": "TurnrModal-module-scss-module__23KbFq__fadeIn",
  "fadeOut": "TurnrModal-module-scss-module__23KbFq__fadeOut",
  "fadeToRed": "TurnrModal-module-scss-module__23KbFq__fadeToRed",
  "header-title": "TurnrModal-module-scss-module__23KbFq__header-title",
  "in": "TurnrModal-module-scss-module__23KbFq__in",
  "killShot": "TurnrModal-module-scss-module__23KbFq__killShot",
  "modal": "TurnrModal-module-scss-module__23KbFq__modal",
  "modal-background-click-part": "TurnrModal-module-scss-module__23KbFq__modal-background-click-part",
  "modal-background-colored": "TurnrModal-module-scss-module__23KbFq__modal-background-colored",
  "modal-container": "TurnrModal-module-scss-module__23KbFq__modal-container",
  "modal-svg": "TurnrModal-module-scss-module__23KbFq__modal-svg",
  "modal-title": "TurnrModal-module-scss-module__23KbFq__modal-title",
  "modalContentFadeIn": "TurnrModal-module-scss-module__23KbFq__modalContentFadeIn",
  "modalContentFadeOut": "TurnrModal-module-scss-module__23KbFq__modalContentFadeOut",
  "modalFadeIn": "TurnrModal-module-scss-module__23KbFq__modalFadeIn",
  "modalFadeOut": "TurnrModal-module-scss-module__23KbFq__modalFadeOut",
  "moveDown": "TurnrModal-module-scss-module__23KbFq__moveDown",
  "moveUp": "TurnrModal-module-scss-module__23KbFq__moveUp",
  "out": "TurnrModal-module-scss-module__23KbFq__out",
  "quickScaleDown": "TurnrModal-module-scss-module__23KbFq__quickScaleDown",
  "roadRunnerIn": "TurnrModal-module-scss-module__23KbFq__roadRunnerIn",
  "roadRunnerOut": "TurnrModal-module-scss-module__23KbFq__roadRunnerOut",
  "scaleBack": "TurnrModal-module-scss-module__23KbFq__scaleBack",
  "scaleDown": "TurnrModal-module-scss-module__23KbFq__scaleDown",
  "scaleForward": "TurnrModal-module-scss-module__23KbFq__scaleForward",
  "scaleUp": "TurnrModal-module-scss-module__23KbFq__scaleUp",
  "sketchIn": "TurnrModal-module-scss-module__23KbFq__sketchIn",
  "sketchOut": "TurnrModal-module-scss-module__23KbFq__sketchOut",
  "slideDownLarge": "TurnrModal-module-scss-module__23KbFq__slideDownLarge",
  "slideUpLarge": "TurnrModal-module-scss-module__23KbFq__slideUpLarge",
  "slowFade": "TurnrModal-module-scss-module__23KbFq__slowFade",
  "title": "TurnrModal-module-scss-module__23KbFq__title",
  "two": "TurnrModal-module-scss-module__23KbFq__two",
  "unfoldIn": "TurnrModal-module-scss-module__23KbFq__unfoldIn",
  "unfoldOut": "TurnrModal-module-scss-module__23KbFq__unfoldOut",
  "zoomIn": "TurnrModal-module-scss-module__23KbFq__zoomIn",
  "zoomOut": "TurnrModal-module-scss-module__23KbFq__zoomOut",
});
